import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'
import {
  Container,
  List,
  Emp,
  ContainerDivs,
  DivAddEmp,
  AddEmp,
  DivDados,
  Grade,
  SpanGradeStudent,
  SpanNameMatter,
  DadosStdt,
  ToGoBack,
  SignMessageButtonText,
  SignMessageButtonTextBold,
  PrintButton,
  SpanFrequency,
  LegendBox,
  DivBimTable,
  DivBimRow,
  DivBimHeader,
  DivBimCell,
  DivNameMatter,
  Preview,
  ContLogo,
  InfoContainer,
  UpContainer
} from './style';

import GlobalStyle from './style';

import {
  getFinalConcepts,
  AttendanceFinalConcepts,
  indexGradesCard,
  fetchLogo,
  clssInfo,
  GetMatter
} from '../../Api';

import { IoCheckmarkSharp, IoCloseSharp } from "react-icons/io5";

import { FcSurvey } from "react-icons/fc";

import { useNavigate } from 'react-router-dom';

import LoadingSpinner from '../../components/Loading';

const FinalConcepts = () => {

  const navigate = useNavigate()
  const [loading, setLoading] = useState(true);
  const [grade, setGrade] = useState([])
  const [stdtName, setStdtName] = useState([])
  const [teacherName, setTeacherName] = useState('')
  const [nameSchool, setNameSchool] = useState('')
  const [logoUrl, setLogoUrl] = useState('');
  const [matters, setMatter] = useState([]);
  const [year, setyear] = useState('')
  const [id_teacher, setId_teacher] = useState('')
  const [id_student, setid_student] = useState('')

  const [highlightedDays, setHighlightedDays] = React.useState([]);
  const [highlightedDaysF, setHighlightedDaysF] = React.useState([]);
  const [highlightedDaysFJ, setHighlightedDaysFJ] = React.useState([]);

  const [iStQuarter, setiStQuarter] = useState([]);
  const [iiNdQuarter, setiiNdQuarter] = useState([]);
  const [iiiRdQuarter, setIIIrdQuarter] = useState([]);
  const [ivThQuarter, setIVthQuarter] = useState([]);

  const [dataCla$$, setdataClass] = useState([]);

  const [assessmentRegime, setAssessmentRegime] = useState('');

  const { idClass } = useParams();

  useEffect(() => {
    (async () => {
      setLoading(true);
      setAssessmentRegime(sessionStorage.getItem('assessmentRegime'))
      const resClass = await clssInfo(idClass);
      setdataClass(resClass)
      const year = new Date().getFullYear();
      //const bimonthly = '1º BIMESTRE'
      const id_student = sessionStorage.getItem("StudentInformation");
      const nameSchool = sessionStorage.getItem("School");
      const stdtName = sessionStorage.getItem("stdt-name");
      const idSchool = JSON.parse(sessionStorage.getItem("id-school"));

      // matérias da escola na ordem do usuário (EF no fim)
      try {
        const resMatter = await GetMatter(idSchool);
        const EF_NAME = 'EDUCAÇÃO FÍSICA';
        const nrm = (s = '') => s.trim().toUpperCase();
        const rawMatters = resMatter.data.data || [];
        const orderedMatters = [...rawMatters].sort((a, b) => {
          const aEF = nrm(a.name) === EF_NAME;
          const bEF = nrm(b.name) === EF_NAME;
          if (aEF) return 1;
          if (bEF) return -1;
          return 0;
        });
        setMatter(orderedMatters);
      } catch (e) {
        console.error('Erro ao buscar matérias:', e);
      }
      setStdtName(stdtName)
      setyear(year)
      setNameSchool(nameSchool)
      setid_student(id_student)
      const resGrade = await getFinalConcepts(year, id_student)
      setGrade(resGrade.data.data)
      console.log("resGrade", resGrade.data.data)

      if (resGrade.data.data) {
        const idTeacher = resGrade.data.data.map(res => {
          return res.id_class.classRegentTeacher
        })
        const Teacher = idTeacher[0];
        setId_teacher(Teacher)
        console.log("idTeacher", Teacher)
      }

      if (year && id_student) {
        const grades = await indexGradesCard(year, id_student)
        if (grades) {
          console.log("grades", grades.data.data);

          // Filtra os objetos para cada bimestre
          const firstQuarter = grades.data.data.filter(res => res.bimonthly === "1º BIMESTRE");
          const secondQuarter = grades.data.data.filter(res => res.bimonthly === "2º BIMESTRE");
          const thirdQuarter = grades.data.data.filter(res => res.bimonthly === "3º BIMESTRE");
          const fourthQuarter = grades.data.data.filter(res => res.bimonthly === "4º BIMESTRE");

          // Atualiza os estados com os arrays filtrados
          setiStQuarter(firstQuarter);
          setiiNdQuarter(secondQuarter);
          setIIIrdQuarter(thirdQuarter)
          setIVthQuarter(fourthQuarter)

          console.log("1º Bimestre", firstQuarter);
          console.log("2º Bimestre", secondQuarter);
        }
      }

      if (resGrade) {
        const allGrades = resGrade.data.data;

        // Verifica se há pelo menos uma matéria com o nome "EDUCAÇÃO FÍSICA"
        const hasPE = allGrades.some(res => res.id_matter.name === "EDUCAÇÃO FÍSICA");

        // Se tiver, move para o final; senão, mantém a ordem original
        const sortedResGrade = hasPE
          ? [
            ...allGrades.filter(res => res.id_matter.name !== "EDUCAÇÃO FÍSICA"),
            ...allGrades.filter(res => res.id_matter.name === "EDUCAÇÃO FÍSICA"),
          ]
          : allGrades;
        const tchr = sortedResGrade.map(res => res.id_employee.name);
        const firstTeacher = tchr[0];  // Acessa o primeiro elemento
        console.log("firstTeacher", firstTeacher);
        setTeacherName(firstTeacher);  // Define apenas o primeiro elemento
      }
      const cachedLogo = localStorage.getItem(`school-logo-${idSchool}`);
      //const cachedLogoId = localStorage.getItem(`school-logo-id-${idSchool}`);

      if (cachedLogo) {
        console.log('busca pelo storage local')
        setLogoUrl(cachedLogo);
        //setlogoId(cachedLogoId);
      } else {

        console.log('busca no s3')
        const logoRes = await fetchLogo(idSchool);

        console.log('busca logo', logoRes)
        if (logoRes?.url) {
          setLogoUrl(logoRes.url);
          //setlogoId(logoRes._id);
          localStorage.setItem(`school-logo-${idSchool}`, logoRes.url);
          localStorage.setItem(`school-logo-id-${idSchool}`, logoRes._id);

        }
      }
      setLoading(false);
    })();

  }, [idClass]);

  useEffect(() => {
    const fetchAttendance = async () => {
      if (year && id_student && id_teacher) {
        try {
          const result = await AttendanceFinalConcepts(year, id_student, id_teacher);
          console.log("result", result)
          const data = result?.data?.data || [];

          // Verifique se os dados estão disponíveis e não estão vazios
          if (data.length > 0) {
            // Filtrando e mapeando as presenças (P)
            const attendance = data.filter(res => res.status === "P");

            // Filtrando e mapeando as faltas (F)
            const attendancef = data.filter(res => res.status === "F");
            const attendancefj = data.filter(res => res.status === "FJ");

            // Garantir que as variáveis não sejam nulas ou indefinidas
            setHighlightedDays(attendance.length ? attendance : []);
            setHighlightedDaysF(attendancef.length ? attendancef : []);
            setHighlightedDaysFJ(attendancefj.length ? attendancefj : []);
          } else {
            console.warn("Nenhum dado de frequência disponível.");
          }
        } catch (error) {
          console.error("Erro ao obter dados de frequência", error);
        }
      }
    };

    fetchAttendance();
  }, [year, id_student, id_teacher]);



  const messageButtonClick = () => {
    navigate(-1);
  };

  const handlePrint = () => {
    window.print();
  };

  const countPresences = highlightedDays.length;
  const countAbsences = highlightedDaysF.length;
  const countjustifiedAbsence = highlightedDaysFJ.length;

  const periodLabel = assessmentRegime === 'TRIMESTRAL' ? 'TRIM' : 'BIM';

  return (
    <Container>
      <GlobalStyle /> {/* Adicionando estilos globais */}
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <ContainerDivs>
            <div className="no-print">
              <h3>Atenção antes de imprimir</h3>
              <p>
                Caso o boletim possua muitas matérias e não caiba totalmente em uma única folha,
                diminua a <strong>escala de impressão</strong> nas configurações da impressora.
                Sugestão: <strong>90%</strong>, <strong>85%</strong> ou <strong>80%</strong>.
              </p>
            </div>
            <PrintButton className="no-print" onClick={handlePrint}>
              Imprimir
            </PrintButton>
            <DivAddEmp id="containerDivs">
              <ContLogo>
                {(logoUrl) && (
                  <Preview src={logoUrl} alt="Logo da escola" />
                )}
                <h2>Boletim</h2>
              </ContLogo>
              <AddEmp>
                <h3>Resultado Final</h3>
              </AddEmp>
              <DadosStdt>
                <UpContainer>
                  <InfoContainer>
                    <span><strong>Escola:</strong> {nameSchool}</span>
                    <span>
                      <strong>Série:</strong> {dataCla$$?.data?.data?.[0]?.serie}
                    </span>

                    <span>
                      <strong>Turma:</strong> {dataCla$$?.data?.data?.[0]?.name}
                    </span>

                    <span>
                      <strong>Ano Letivo:</strong> {dataCla$$?.data?.data?.[0]?.year}
                    </span>
                    <span><strong>Professor:</strong> {teacherName}</span>
                    <span><strong>Aluno:</strong> {stdtName}</span>
                  </InfoContainer>
                  <SpanFrequency>
                    <span><IoCheckmarkSharp color='#00fa00' font-size="30px" />Presenças: {countPresences} | <IoCloseSharp color='#ff050a' font-size="30px" />Faltas: {countAbsences}</span>
                    <span><FcSurvey font-size="25px" />Faltas justificada: {countjustifiedAbsence}</span>
                  </SpanFrequency>
                </UpContainer>
                <LegendBox>
                  <h3>Legenda</h3>
                  <p><strong style={{ color: 'var(--green)' }}>A</strong> - Alcançou com êxito as capacidades básicas</p>
                  <p><strong style={{ color: '#3b82f6' }}>B</strong> - Alcançou satisfatoriamente as capacidades básicas</p>
                  <p><strong style={{ color: '#e08a0b' }}>C</strong> - Alcançou parcialmente as capacidades básicas</p>
                  <p><strong style={{ color: 'var(--coral, #e5484d)' }}>D</strong> - Não alcançou as capacidades básicas</p>
                </LegendBox>
              </DadosStdt>
              <DivDados>
                <List>
                  {
                    grade
                      .sort((a, b) => {
                        // ordena conforme a ordem definida pelo usuário (campo
                        // `order` vindo do GetMatter), com a Educação Física no fim
                        const norm = (s = '') => s.trim().toUpperCase();
                        const orderIndex = new Map((matters || []).map((m, i) => [norm(m.name), i]));
                        const big = Number.MAX_SAFE_INTEGER;
                        const ia = orderIndex.has(norm(a.id_matter.name)) ? orderIndex.get(norm(a.id_matter.name)) : big;
                        const ib = orderIndex.has(norm(b.id_matter.name)) ? orderIndex.get(norm(b.id_matter.name)) : big;
                        return ia - ib;
                      })
                      .map(grd => (
                        <Emp
                          key={grd._id} >
                          <DivNameMatter>
                            <SpanNameMatter>{grd.id_matter.name}</SpanNameMatter>
                          </DivNameMatter>
                          <Grade>
                            <DivBimTable>
                              <DivBimRow>
                                <DivBimHeader>1º {periodLabel}</DivBimHeader>
                                <DivBimCell grade={iStQuarter.find((q) => q.id_matter === grd.id_matter._id)?.studentGrade || "N/A"}>
                                  {iStQuarter.find((q) => q.id_matter === grd.id_matter._id)?.studentGrade || "N/A"}
                                </DivBimCell>
                              </DivBimRow>
                              <DivBimRow>
                                <DivBimHeader>2º {periodLabel}</DivBimHeader>
                                <DivBimCell grade={iiNdQuarter.find((q) => q.id_matter === grd.id_matter._id)?.studentGrade || "N/A"}>
                                  {iiNdQuarter.find((q) => q.id_matter === grd.id_matter._id)?.studentGrade || "N/A"}
                                </DivBimCell>
                              </DivBimRow>
                              <DivBimRow>
                                <DivBimHeader>3º {periodLabel}</DivBimHeader>
                                <DivBimCell grade={iiiRdQuarter.find((q) => q.id_matter === grd.id_matter._id)?.studentGrade || "N/A"}>
                                  {iiiRdQuarter.find((q) => q.id_matter === grd.id_matter._id)?.studentGrade || "N/A"}
                                </DivBimCell>
                              </DivBimRow>
                              <DivBimRow>
                                <DivBimHeader>4º Bim</DivBimHeader>
                                <DivBimCell grade={ivThQuarter.find((q) => q.id_matter === grd.id_matter._id)?.studentGrade || "N/A"}>
                                  {ivThQuarter.find((q) => q.id_matter === grd.id_matter._id)?.studentGrade || "N/A"}
                                </DivBimCell>
                              </DivBimRow>
                              {assessmentRegime !== 'TRIMESTRAL' && (
                                <DivBimRow>
                                  <DivBimHeader>Final</DivBimHeader>
                                  <DivBimCell><SpanGradeStudent grade={grd.studentGrade}>{grd.studentGrade}</SpanGradeStudent></DivBimCell>
                                </DivBimRow>
                              )}
                            </DivBimTable>
                            {/*<SpanTotalGrade><p>Total</p>{grd.totalGrade}</SpanTotalGrade>
                          <SpanAverageGrade><p>Media</p>{grd.averageGrade}</SpanAverageGrade>*/}
                            {/*<SpanGradeStudent grade={grd.studentGrade} /*average={grd.averageGrade}><p>Desempenho</p>{grd.studentGrade}</SpanGradeStudent>*/}
                          </Grade>
                        </Emp>
                      ))
                  }
                </List>
              </DivDados>
            </DivAddEmp>
          </ContainerDivs>
          <ToGoBack onClick={messageButtonClick}>
            <SignMessageButtonText>Voltar para o</SignMessageButtonText>
            <SignMessageButtonTextBold>Perfil do Aluno</SignMessageButtonTextBold>
          </ToGoBack>
        </>
      )}
    </Container>
  )
}

export default FinalConcepts